var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-tag',{attrs:{"rounded":"","size":_vm.size,"type":_vm.type}},[_c('b-tooltip',{attrs:{"type":_vm.type,"label":_vm.role.description,"multilined":""}},[_vm._v(_vm._s(_vm._f("capitalize")(_vm.role.name)))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }